<div class="session-timer">
    <p class="timer-title">{{'sessionTimer.sessionTitle' | translate }}</p>
    <p class="timer">
        <span *ngIf="sessionTimerData.sessionMonths">{{ formatNumber(sessionTimerData.sessionMonths)}}+"m":</span>
        <span *ngIf="sessionTimerData.sessionMonths">{{ formatNumber(sessionTimerData.sessionDays)}}+"d":</span>
        <span>{{ formatNumber(sessionTimerData.sessionHours)}}:</span>
        <span>{{formatNumber(sessionTimerData.sessionMinutes)}}:</span>
        <span>{{ formatNumber(sessionTimerData.sessionSeconds)}}</span>
    </p>
</div>